import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import {
  formatoSeparadorMilesReturn,
  splitImporte,
  formatoSeparadorMilesValue
} from "../../../generico/utils/FormatoInput";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import Select from "react-select";
import PagoDepositoExtraccionQrService from "../../../../services/operaciones-qr/PagoDepositoExtraccionQrService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default class PagoDepositoExtraccionQrPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    cuentasOrigen: "",
    monto: 0,
    comercio: "",
    tipoQR: "",
    accionQR:"",
    formaPago: "",
    motivo: "",
    nroOperacion: 0,
    disableSgte: true,
    otrosDesc: "",
    cuentaOrigenSelected: "",
    modalidadPago: { value: "-1", label: "--Seleccione--" },
    itemSelected: { value: "-1", label: "--Seleccione--" },
    itemTCOSelected: { value: "-1", label: "--Seleccione--" },
    datosTipoQR:{},
    listaFormasPago:[{ value:"CCAHOO", label:"CUENTA DE AHORRO" }],
    atmOComercio: "Comercio"
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.getCuentas();
    this.getTarjetas();
    if (this.props.datosQR.importe !== undefined) {
      let montoInit = formatoSeparadorMilesValue(this.props.datosQR.importe);
      this.setState({ monto: montoInit });
    }
    if (this.props.datosQR.titularDestinatario !== undefined) {
      this.setState({ comercio: this.props.datosQR.titularDestinatario });
    }
    if(this.props.datosQR.codOperacion !== undefined){
      this.atmOComercio = "Comercio";
      if(this.props.datosQR.origenQr == 'BANCARDATM'){
        this.titulo='Extracción ATM con QR';
        this.formaPago='Extracción ATM de:';
        this.accionQR='Confirmar';
        this.tipoQR='Extracción ATM';
        this.atmOComercio = "ATM"
        this.setState({ tipoQR: "EXTRACCIÓN ATM", accionQR: "Confirmar", formaPago: "Extracción ATM", atmOComercio: "ATM" });
      } else if(this.props.datosQR.codOperacion == 'DEPO'){
        this.titulo='Depósito con QR';
        this.formaPago='Depósito en:';
        this.accionQR='Depositar';
        this.tipoQR='Depósito';
        this.operacionCuenta='CREDITO';
        this.setState({ tipoQR: "DEPÓSITO", accionQR: "Depositar", formaPago: "Depósito" });
      } else if(this.props.datosQR.codOperacion == 'EXTR'){
        this.titulo='Extracción con QR'
        this.formaPago='Extracción de:';
        this.accionQR='Extraer';
        this.tipoQR='Extracción';
        this.operacionCuenta='DEBITO';
        this.setState({ tipoQR: "EXTRACCIÓN", accionQR: "Extraer", formaPago: "Extracción"  });
      }  else if(this.props.datosQR.codOperacion == 'COMP' || this.props.datosQR.origenQr == 'BANCARD'){
        this.titulo='Compra con QR'
        this.formaPago='Forma de Pago:';
        this.accionQR='Pagar';
        this.tipoQR='Pago';
        this.operacionCuenta='DEBITO';
        this.setState({ tipoQR: "COMPRA", accionQR: "Pagar", formaPago: "Pago"  });
      }  else if(this.props.datosQR.codOperacion == 'TRANF'){
        this.titulo='Transferencia con QR'
        this.setState({ tipoQR: "TRANSFERENCIA" });
      }
      if(this.props.datosQR.origenQr !== 'BANCARD'){ // agregar opcion de pago con tarjeta
        this.state.listaFormasPago.push({
          value:"TCO",
          label:"TARJETA"
        })
      }
      this.setState({ datosTipoQR:{
        titulo: this.titulo,
        formaPago: this.formaPago,
        accionQR: this.accionQR,
        tipoQR: this.tipoQR,
        atmOComercio: this.atmOComercio
      }});
    }    
  }

  getCuentas() {
    trackPromise(
      TransferCuentasPropiasService.getCuentas("I").then((response) => {
        if (response.data.codigo !== "0" && response.data.mensaje === "SIN RESULTADOS") {
          Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
        }
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        this.setState({ cuentasOrigen: jsonData.resultadoAH });
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  getTarjetas() {
    trackPromise(
      PagoDepositoExtraccionQrService.getTarjetasCabal().then((response) => {
        var resp = response.data;
        if (resp.codigoRetorno === "0") {
          if (resp.datos[0] !== null) {
            this.state.options = [];
            this.tarjetaList = [];
            for (let index = 0; index < resp.datos.length; index++) {
              //// filtra las tarjetas Master del listado
              let tipoTarjeta = this.obtenerTipoTarjeta(resp.datos[index].numeroTarjeta);
              if (tipoTarjeta === "MASTER" || resp.datos[index].sucursal === 81) {
                continue;
              }
              let tarjeta = {
                id: resp.datos[index].numeroTarjeta,
                detalle: resp.datos[index].numeroTarjeta,
                tipo: tipoTarjeta,
                saldo: resp.datos[index].limiteCompra,
                moneda: "GS",
                formaPago: "TARJETA",
                codFormaPago: "TCO",
                disponible: resp.datos[index].disponible,
                sobregiro: resp.datos[index].sobregiro,
                dispMasSobregiro: resp.datos[index].dispMasSobregiro
              }
              this.tarjetaList.push(tarjeta);
              var nro = resp.datos[index].numeroTarjeta;
              this.state.options.push({
                value: resp.datos[index].numeroTarjeta,
                label:
                nro.substring(0, 4) + "****" + nro.substring(nro.length - 4, nro.length) +
                  " - " +
                  tipoTarjeta +
                  " Disponible: " +
                  formatoSeparadorMilesValue(resp.datos[index].disponible) +
                  " " +
                  "GS" +
                  ".",
              });
            }
            this.setState({ tarjetaList: this.tarjetaList });

          } else {
            this.notifiPopup("Atención", "Sin resultados");
          }

        } else {
          if (resp.codigoRetorno !== 401) {
            this.notifiPopup("Error", resp["mensajeRetorno"]);
          }
        }
        
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  obtenerTipoTarjeta(nroTarjeta) {
    var prefijo = nroTarjeta.substring(0, 4);
    if (prefijo === "5150" || prefijo === "5418" || prefijo === "5358" || prefijo === "5402") {
      return "MASTER";
    }
    if (prefijo === "6020") {
      return "PANAL";
    }
    if (prefijo === "5896" || prefijo === "6042") {
      return "CABAL";
    }
  }

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.cuenta,
        detalleCuenta: dataFromChild.cuenta + " " + dataFromChild.denominacion,
        itemSelected: item,
      }
    );
    this.enableNextForBoth(item.value)
  };

  enableNextForBoth(itemValue){
    if(this.props.datosQR.codOperacion === 'TRANF'){
      this.enableNext(this.state.monto, this.state.motivo, this.state.otrosDesc);
    } else {
      this.enableNext(this.state.monto, this.state.modalidadPago.value, itemValue)
    }
  }

  enableNext(monto, modalidadPagoOmotivo, valueCuentaOTarjetaOtrosDesc) {
    if(this.props.datosQR.codOperacion === 'TRANF'){
      if(this.state.cuentaOrigenSelected === ""){
        this.setState({ disableSgte: true })
        return;
      }
      if (monto === "") {
        this.setState({ disableSgte: true })
        return;
      }
      if (modalidadPagoOmotivo === "") {
        this.setState({ disableSgte: true })  
        return;
      }
      if (modalidadPagoOmotivo === "Otros" && valueCuentaOTarjetaOtrosDesc === "") {
        this.setState({ disableSgte: true })
        return
      }
    } else {
      if (this.props.datosQR.origenQr !== 'BANCARDATM' && (monto === "" || monto === 0)) {
        this.setState({ disableSgte: true })
        return;
      }
      if (modalidadPagoOmotivo === "" || modalidadPagoOmotivo === undefined) {
        this.setState({ disableSgte: true })
        return;
      }
      if (valueCuentaOTarjetaOtrosDesc === undefined || valueCuentaOTarjetaOtrosDesc === "" 
        || valueCuentaOTarjetaOtrosDesc === "-1") {
        this.setState({ disableSgte: true })
        return;
      }
    }   

    this.setState({ disableSgte: false })

  }

  onChangeModalidadPago(newValue){
    if (newValue === "CCAHOO"){
      this.setState({
        itemTCOSelected: { value: "-1", label: "--Seleccione--" },
        modalidadPago: {value: newValue, label: "CUENTA DE AHORRO"},
        disableSgte: true
      })
    } else {
      this.setState({
        itemSelected: { value: "-1", label: "--Seleccione--" },
        modalidadPago: {value: newValue, label: "TARJETA"},
        disableSgte: true
      })
    }   
    this.enableNext(this.state.monto, newValue, undefined);
  }

  onChangeTarjeta(value, label){
    this.setState({itemTCOSelected:{ value: value, label: label }});
    this.enableNext(this.state.monto, this.state.modalidadPago.value, value);
  }  

  render() {
    if(this.props.datosQR.codOperacion == 'TRANF'){
      return (
        <div>
          <form id="idFormPaso2" onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="steps clearfix">
                <ul role="tablist">
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">
                        <span className="title_text current">
                          Leer código QR
                        </span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="current">
                    <span>
                      <div className="title">
                        <span className="title_text">Datos del QR</span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled">
                    <span>
                      <div className="title">
                        <span className="title_text">Datos de Verificación</span>
                      </div>
                    </span>
                  </li>
                  <li role="tab" className="disabled last">
                    <span>
                      <div className="title">
                        <span className="title_text">Confirmación</span>
                      </div>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
  
            <div className="row justify-content-md-center">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="input-label-bold">Tipo QR *</label>
                  <input disabled={true} value={this.state.tipoQR} type="text" name="tipoQR"
                    className="form-control input-box"/>
                </div>  
                <CuentaSocioTransferencia
                  selectorValue={this.selectorValue.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.itemSelected}
                />
                <div className="form-group">
                  <label className="input-label-bold">Cuenta Destino *</label>
                  <input disabled={true} value={this.props.datosQR.numCuentaDestino} type="text" name="cuentaDestino"
                    className="form-control input-box"
                  />
                </div>
                <div className="form-group">
                  <label className="input-label-bold">Titular de la Cuenta Destino *</label>
                  <input disabled={true} value={this.props.datosQR.titularDestinatario} type="text" name="titularCuentaDestino"
                    className="form-control input-box"
                  />
                </div>
                <div className="form-group">
                  <label className="input-label-bold">Importe a Transferir *</label>
                  <input disabled={true} value={this.state.monto} type="text" maxLength="19" name="monto"
                    className="form-control input-box"
                    onChange={(evt) => {
                      var _monto = formatoSeparadorMilesReturn(evt);
                      if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                        _monto = _monto.substr(1);
                      }
                      this.setState({
                        monto: _monto,
                      });
                      _monto = splitImporte(_monto);
                      this.enableNext(parseFloat(_monto), this.state.motivo, this.state.otrosDesc);
                    }}
                  />
                </div>
                <div className="form-group">
                  <label className="input-label-bold">
                    Motivo de la Transferencia *
                  </label>
                  <select
                    value={this.state.motivo}
                    className="form-control input-box"
                    onChange={(evt) => {
                      this.setState({
                        motivo: evt.target.value,
                      });
                      this.enableNext(this.state.monto, evt.target.value, this.state.otrosDesc);
                    }}
                  >
                    <option key="-1" value="" disabled>
                      -- Seleccione--
                    </option>
                    <option value="Prestación de Servicios Personales">
                      Prestación de Servicios Personales
                    </option>
                    <option value="Compras de Productos Varios">
                      Compras de Productos Varios
                    </option>
                    <option value="Fondos Familiares">Fondos Familiares</option>
                    <option value="Ayuda Solidaria">Ayuda Solidaria</option>
                    <option value="Otros">Otros</option>
                  </select>
                </div>
  
                <div className="form-group">
                  {this.state.motivo === "Otros" && (
                    <textarea
                      rows="4"
                      cols="50"
                      value={this.state.otrosDesc}
                      name="otrosDsc"
                      className="form-control input-box"
                      onChange={(evt) => {
                        this.setState({ otrosDesc: evt.currentTarget.value });
                        this.enableNext(this.state.monto, this.state.motivo, evt.currentTarget.value);
                      }}
                    ></textarea>
                  )}
                </div>
              </div>
            </div>
            <hr />
  
            <div className="row">
              <div className="col-lg-8">
                  <label
                    className="input-label-bold-obligatorio">
                    (*) Campos Obligatorios
                    <br />
                  </label>
                
              </div>
              <div className="col-md-2">
                  <button
                    className="btn btn-cu-quintary btn-consulta"
                    onClick={() => {
                      this.props.previousStep();
                    }}
                  >
                  <FontAwesomeIcon icon={faArrowLeft} />  Volver
                  </button>
                  
             
              </div>
              <div className="col-md-2">
              <button
                    className="btn btn-cu-primary"
                    disabled={this.state.disableSgte}
                    onClick={() => {
                      var _motivo = (this.state.motivo === "Otros" ? this.state.otrosDesc : this.state.motivo)
                      this.props.returnDataPaso2(this.state.tipoQR, null, this.state.monto, _motivo, this.state.cuentaOrigenSelected);
                        this.nextStep.click();
                    }}
                  >
                    Continuar <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                  <button
                    hidden
                    ref={(a) => (this.nextStep = a)}
                    className="btn btn-cu-primary"
                    onClick={this.props.nextStep}
                  ></button>
              </div>
            </div>
  
          </form>
        </div>
      );
    }
    return (
      <div>
        <form id="idFormPaso2" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Leer código QR
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos del QR</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row justify-content-md-center">
            <div className="col-lg-8 col-md-10"> 
            <div className="form-group">
                <label className="input-label-bold">Tipo QR *</label>
                <input disabled={true} value={this.state.tipoQR} type="text" name="tipoQR"
                  className="form-control input-box"/>
              </div>   
              <div className="form-group">
                <label className="input-label-bold">{this.state.atmOComercio} *</label>
                <input disabled={true} value={this.state.comercio} type="text" name="comercio"
                  className="form-control input-box"/>
              </div>       
              {this.props.datosQR.origenQr !== 'BANCARDATM' && (
              <div className="form-group">
                <label className="input-label-bold">Importe a {this.state.accionQR} *</label>
                <input disabled={true} value={this.state.monto} type="text" maxLength="19" name="monto"
                  className="form-control input-box"
                  onChange={(evt) => {
                    var _monto = formatoSeparadorMilesReturn(evt);
                    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                      _monto = _monto.substr(1);
                    }
                    this.setState({
                      monto: _monto,
                    });
                    _monto = splitImporte(_monto);
                  }}
                />
              </div>
              )}
              <div className="form-group">
                <label className="input-label-bold">
                  Forma de {this.state.formaPago} *
                </label>
                <Select
                  required="required"
                  placeholder="-- Seleccione --"
                  options={this.state.listaFormasPago}
                  value={this.state.modalidadPago}
                  isClearable
                  noOptionsMessage={() => "SIN DATOS"}
                  onChange={(evt) => {
                    this.onChangeModalidadPago(evt.value);
                  }}
                />
              </div>

              <div className="form-group">
                {(this.state.modalidadPago.value === "CCAHOO") &&
                  <CuentaSocioTransferencia
                    selectorValue={this.selectorValue.bind(this)}
                    operacion={this.operacionCuenta}
                    tipoCuenta="AHORRO_VISTA"
                    items={this.state.cuentasOrigen}
                    itemSelected={this.state.itemSelected}
                  />
                }
              </div>

              <div className="form-group">
              {(this.state.modalidadPago.value === "TCO") &&
                (this.props.datosQR.codOperacion == 'DEPO') &&
                <label className="input-label-bold">
                  Seleccione la Tarjeta (a acreditar) *
                </label>
              } 
              {(this.state.modalidadPago.value === "TCO") &&
                !(this.props.datosQR.codOperacion == 'DEPO') &&
                <label className="input-label-bold">
                  Seleccione la Tarjeta (a debitar) *
                </label>
              }   
              {(this.state.modalidadPago.value === "TCO") &&             
                <Select
                  required="required"
                  placeholder="-- Seleccione --"
                  value={this.state.itemTCOSelected}
                  options={this.state.options}
                  isClearable
                  onChange={(evt) => {
                    this.onChangeTarjeta(evt.value, evt.label);
                  }}
                  noOptionsMessage={() => "SIN DATOS"}
                />
              }
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            
            <div className="col-lg-8 col-md-6">
                <label
                  className="input-label-bold-obligatorio">
                  (*) Campos Obligatorios
                  <br />
                </label>
            </div>
            <div className="col-lg-2 col-md-3">
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={() => {
                    this.props.previousStep();
                  }}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>
                
                <button
                  hidden
                  ref={(a) => (this.nextStep = a)}
                  className="btn btn-cu-primary"
                  onClick={this.props.nextStep}
                ></button>
            </div>
            <div className="col-lg-2 col-md-3">
            <button
                  className="btn btn-cu-primary"
                  disabled={this.state.disableSgte}
                  onClick={() => {
                    if(this.state.modalidadPago.value === "TCO"){
                      this.props.returnDataPaso2(this.state.datosTipoQR, this.state.comercio, this.state.monto, this.state.modalidadPago.value, this.state.itemTCOSelected);  
                    } else {
                      this.props.returnDataPaso2(this.state.datosTipoQR, this.state.comercio, this.state.monto, this.state.modalidadPago.value, this.state.cuentaOrigenSelected);
                    }
                    this.nextStep.click();
                  }}
                >
                  Continuar <FontAwesomeIcon icon={faArrowRight} />
                </button>
            </div>
          </div>
         
        </form>
      </div>
    );
  }
}
